import { Action } from 'redux-actions';
import { all, put, select, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getSparePartCatalogsRequest } from '../../../api/Actor/getSparePartCatalogsQuery';
import { getSparePartCatalogsBySupplierIdRequest } from '../../../api/SparePart/getSparePartCatalogsBySupplierIdQuery';

import {
  GetSparePartCatalogsBySupplierIdPayload,
  GetSparePartCatalogsPayload,
} from './actionCreators';
import * as types from './actionTypes';
import {
  selectGetSparePartCatalogBySupplierIdIsLoading,
  selectGetSparePartCatalogBySupplierIdWasLoaded,
  selectGetSparePartCatalogIsLoading,
  selectGetSparePartCatalogWasLoaded,
} from './selectors';

function* getSparePartCatalogWorker({
  payload,
}: {
  payload: GetSparePartCatalogsPayload;
}): Generator {
  const { sparePartCatalogId = null } = payload;

  if (!sparePartCatalogId) {
    return;
  }

  const isLoading = yield select(selectGetSparePartCatalogIsLoading, {
    sparePartCatalogId,
  });
  const wasLoaded = yield select(selectGetSparePartCatalogWasLoaded, {
    sparePartCatalogId,
  });

  if (isLoading || wasLoaded) {
    return;
  }

  yield executeSagaRequest(
    types.GET_SPARE_PART_CATALOG,
    getSparePartCatalogsRequest({ sparePartCatalogId }),
    { indexer: sparePartCatalogId },
  );

  yield put(types.GET_SPARE_PART_CATALOG.end({ sparePartCatalogId }));
}
function* getSparePartCatalogWatcher() {
  yield takeEvery<Action<GetSparePartCatalogsPayload>>(
    types.GET_SPARE_PART_CATALOG.BASE,
    getSparePartCatalogWorker,
  );
}

function* getSparePartCatalogsBySupplierIdWorker({
  payload,
}: {
  payload: GetSparePartCatalogsBySupplierIdPayload;
}): Generator {
  const { supplierId, sellerId, query } = payload;

  if (!supplierId || !sellerId) {
    return;
  }

  const isLoading = yield select(
    selectGetSparePartCatalogBySupplierIdIsLoading,
    { supplierId, query },
  );
  const wasLoaded = yield select(
    selectGetSparePartCatalogBySupplierIdWasLoaded,
    { supplierId, query },
  );

  if (isLoading || wasLoaded) {
    return;
  }

  yield executeSagaRequest(
    types.GET_SPARE_PART_CATALOGS_BY_SUPPLIER_ID,
    getSparePartCatalogsBySupplierIdRequest({ supplierId, sellerId, query }),
    {
      supplierId,
      sellerId,
      indexer: `${supplierId}.${query}`,
    },
  );

  yield put(types.GET_SPARE_PART_CATALOGS_BY_SUPPLIER_ID.end({ supplierId }));
}
function* getSparePartCatalogsBySupplierIdWatcher() {
  yield takeEvery<Action<GetSparePartCatalogsBySupplierIdPayload>>(
    types.GET_SPARE_PART_CATALOGS_BY_SUPPLIER_ID.BASE,
    getSparePartCatalogsBySupplierIdWorker,
  );
}

export default function* sparePartCatalogSaga(): Generator {
  try {
    yield all([
      getSparePartCatalogWatcher(),
      getSparePartCatalogsBySupplierIdWatcher(),
    ]);
  } catch (error) {
    logCritical(error as any);
  }
}
